import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { makeStyles } from '@rentacenter/racstrap';
import { appConfig } from '../../config/app-config';
import { MicroFrontend } from './MicroFrontEnd';

export const testId = 'storeTestId';
const useStyles = makeStyles(() => ({
  microAppContainer: {
    marginTop: '4rem',
  },
}));

export const DOF = ({ history }: RouteComponentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.microAppContainer} data-testid={testId}>
      <MicroFrontend
        config={appConfig.microfrontends.store}
        history={history}
      />
    </div>
  );
};
